import { useAtom } from "jotai";

import { userDataAtom } from "../atoms/auth-atom";

export const useUserData = () => {
  const [userData, setUserData] = useAtom(userDataAtom);

  return [userData, setUserData] as const;
};
